import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8 col-12" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row flex-fill justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-column pt-7 ps-4" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Invited users"),
    /*#__PURE__*/_createElementVNode("span", { class: "fs-7 text-muted" }, "List of reffered users")
  ])
], -1)
const _hoisted_3 = { class: "card-body pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_ReferredUsersDataTable = _resolveComponent("ReferredUsersDataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_ReferredUsersDataTable, {
            key: 1,
            data: _ctx.referredUsers
          }, null, 8, ["data"])),
      _createVNode(_component_Pagination, {
        class: "pb-5",
        currentPage: _ctx.pagination.currentPage,
        totalPages: _ctx.pagination.lastPage,
        onChangeCurrentPage: _ctx.handleChangePage
      }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
    ])
  ]))
}